export default "__VITE_ASSET__db3b3fa6__"